const INTIAL_STATE = {
  language: sessionStorage.getItem("Language") || "jp",
  orgDetails: {},
};

export default (state = INTIAL_STATE, action) => {
  switch (action.type) {
    case "language":
      return Object.assign({}, state, { language: action.payload.data });
    case "ORG_DETAILS":
      return Object.assign({}, state, { orgDetails: action.payload });
    default:
      return state;
  }
};
